export {SafeHtml} from './safeHtml.pipe';
export {AsyncIMG} from './asyncIMG.pipe';


// WEBPACK FOOTER //
// ./src/app/pipes/index.ts